import React from 'react';
import { useOptionalAuth } from '../contexts/AuthContext';
import { fetchPayApplies } from '../lib/payments';

// Whether Pay applies to the signed-in student (JTP-29). False until the answer arrives, for a
// visitor who is signed out, for anyone who is not a student, and when the read fails.
export function usePayApplies() {
  const auth = useOptionalAuth();
  const user = auth?.user || null;
  const [answer, setAnswer] = React.useState({ id: null, applies: false });
  React.useEffect(() => {
    let live = true;
    fetchPayApplies(user).then((applies) => {
      if (live) setAnswer({ id: user?.id ?? null, applies });
    });
    return () => { live = false; };
  }, [user?.id, user?.role]); // eslint-disable-line react-hooks/exhaustive-deps
  // An answer for another user (a sign-out, a different sign-in) never shows.
  return Boolean(user) && answer.id === user.id && answer.applies;
}
